import React from "react";
import { Progress } from "@/components/ui/progress";
import { useAppStore } from "@/stores/app.store";
import { useDeviceStore } from "@/stores/device.store";
import { useHistoryStore } from "@/stores/history.store";
import { Smartphone, HardDrive, Cpu, Database, Battery, Shield } from "lucide-react";

export const StatusBar: React.FC = () => {
  const { status, progress, speed } = useAppStore();
  const { deviceInfo, isConnected, deviceName } = useDeviceStore();
  const { history } = useHistoryStore();

  return (
    <footer className="h-8 border-t bg-muted/30 px-4 flex items-center text-xs text-muted-foreground select-none">
      <div className="flex items-center gap-4 flex-1">
        <div className="flex items-center gap-1.5">
          <HardDrive className="w-3.5 h-3.5" />
          <span>{status}</span>
        </div>

        {isConnected && (
          <div className="flex items-center gap-1.5 border-l pl-4">
            <Smartphone className="w-3.5 h-3.5 text-green-500" />
            <span>{deviceName}</span>
          </div>
        )}

        {isConnected && deviceInfo && (
          <>
            <div className="flex items-center gap-1.5 border-l pl-4">
              <span>Android {deviceInfo.androidVersion}</span>
            </div>
            <div className="flex items-center gap-1.5 border-l pl-4">
              <Battery className={`w-3.5 h-3.5 ${deviceInfo.battery <= 20 ? 'text-red-500' : deviceInfo.battery <= 50 ? 'text-yellow-500' : 'text-green-500'}`} />
              <span>{deviceInfo.battery}%</span>
            </div>
            <div className="flex items-center gap-1.5 border-l pl-4">
              <Shield className={`w-3.5 h-3.5 ${deviceInfo.isRooted ? 'text-orange-500' : ''}`} />
              <span>{deviceInfo.isRooted ? '已ROOT' : '未ROOT'}</span>
            </div>
            <div className="flex items-center gap-1.5 border-l pl-4">
              <Database className="w-3.5 h-3.5" />
              <span>{deviceInfo.storage.used} / {deviceInfo.storage.total}</span>
              <Progress value={deviceInfo.storage.percent} className="h-1.5 w-16" />
              <span>{deviceInfo.storage.percent}%</span>
            </div>
          </>
        )}

        <div className="flex items-center gap-1.5 border-l pl-4">
          <Cpu className="w-3.5 h-3.5" />
          <span>历史: {history.length} 项</span>
        </div>
      </div>

      <div className="flex items-center gap-6">
        {progress !== null && (
          <div className="flex items-center gap-3 w-48">
            <Progress value={progress} className="h-1.5" />
            <span className="tabular-nums min-w-[3ch]">{Math.round(progress)}%</span>
          </div>
        )}

        {speed && (
          <div className="flex items-center gap-1.5 border-l pl-4">
            <Cpu className="w-3.5 h-3.5" />
            <span className="tabular-nums">{speed}</span>
          </div>
        )}

        <div className="border-l pl-4">
          {new Date().toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' })}
        </div>
      </div>
    </footer>
  );
};
